export default __webpack_public_path__ + "assets/Hive Capture Bag Demo Render.30ae2c9a.png";